import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import SrPDCreate from './PumpSpareDomestic/Create';
import SrPICreate from './PumpSpareInternational/Create';
import SalesMDCreate from './ManufacturingDomestic/Create';
import SrMICreate from './ManufacturingInternational/Create';

function SrCreate() {
    const [salereturnstype, setsalereturnstype] = useState('');
    const [salesreturncategory, setsalesreturncategory] = useState('');
    const [salereturnstypeDisabled, setsalereturnstypeDisabled] = useState(false);
    const [salesreturncategoryDisabled, setsalesreturncategoryDisabled] = useState(false);

    const handlesalereturnstypeChange = (event) => {
        const selectedsalereturnstype = event.target.value; 
        setsalereturnstype(selectedsalereturnstype);
        setsalesreturncategory('');
        setsalesreturncategoryDisabled(false);
        setsalereturnstypeDisabled(true);
    };

    const handlesalesreturncategoryChange = (event) => {
        setsalesreturncategory(event.target.value);
        setsalesreturncategoryDisabled(true);
    };

    const PageDisplay = () => {
        if (salereturnstype === 'Pump Spare') {
            if (salesreturncategory === 'Domestic') {
                return <SrPDCreate />;
            } else if (salesreturncategory === 'International') {
                return <SrPICreate />;
            }
        } else if (salereturnstype === 'Manufacturing') {
            if (salesreturncategory === 'Domestic') {
                return <SalesMDCreate />;
            } else if (salesreturncategory === 'International') {
                return <SrMICreate />;
            }
        }
        return null;
    };

    return (
            <Card className="card">
                <Card.Header className="card-header">
                    <h6>ADD SALES REJECTION</h6>
                    <Link to="/srindex/1">
                        <button className="button-70">BACK</button>
                    </Link>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md="6">
                            <Form.Group>
                                <Form.Label>Select Product Type:</Form.Label>
                                <Form.Select
                                    onChange={handlesalereturnstypeChange}
                                    value={salereturnstype}
                                    disabled={salereturnstypeDisabled}
                                >
                                    <option value="">--Please choose an option--</option>
                                    <option value="Pump Spare">Pump Spare</option>
                                    <option value="Manufacturing">Manufacturing</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {(salereturnstype === 'Pump Spare' || salereturnstype === 'Manufacturing') && (
                            <Col md="6">
                                <Form.Group>
                                    <Form.Label>Select Product Category:</Form.Label>
                                    <Form.Select
                                        onChange={handlesalesreturncategoryChange}
                                        value={salesreturncategory}
                                        disabled={salesreturncategoryDisabled}
                                    >
                                        <option value="">--Please choose an option--</option>
                                        <option value="Domestic">Domestic</option>
                                        <option value="International">International</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        )}
                        {PageDisplay()}
                    </Row>
                </Card.Body>
            </Card>
    );
}

export default SrCreate;
